// extracted by mini-css-extract-plugin
export var dropdownIcon = "_nx-6";
export var imgContainer = "_nx-3";
export var menuIcon = "_nx-5";
export var pillWrapper = "_nx-2";
export var pillsContainer = "_nx-1";
export var subscriptionCard = "_nx-0";
export var subscriptionLogo = "_nx-4";